import { Component, Input } from '@angular/core';
import { ViewMode } from '../../../../models';

@Component({
  selector: 'gift-note-example',
  templateUrl: './gift-note-example.component.html',
  styleUrls: ['./gift-note-example.component.scss'],
  standalone: false,
})
export class GiftNoteExampleComponent {
  @Input() template;
  @Input() mode: ViewMode = null;
  @Input() isMobile: boolean = false;
}
